import React, { useRef, useState } from 'react'
import { uploadToR2 } from './r2'
import { useAvatars } from './useAvatars'

const FAMILY_MEMBERS = [
  { email: 'kkdbailey@gmail.com', name: 'Kevin', color: '#e94560' },
  { email: 'moniquebailey1026@gmail.com', name: 'Monique', color: '#5856d6' },
  { email: 'natashabbhatt@gmail.com', name: 'Tasha', color: '#ff9f0a' },
  { email: 'karahauswirth@gmail.com', name: 'Kara', color: '#30d158' },
  { email: 'perniel.grace19@gmail.com', name: 'Grace', color: '#64d2ff' },
  { email: 'mtraetin@gmail.com', name: 'Traetin', color: '#bf5af2' },
  { email: 'ravibhatt150@gmail.com', name: 'Ravi', color: '#ff6b6b' },
]

function getMember(email) {
  const lower = email?.toLowerCase()
  return FAMILY_MEMBERS.find(m => m.email.toLowerCase() === lower) ||
    { name: email?.split('@')[0] || '?', color: '#8e8e93' }
}

// Shared Avatar component — use this everywhere instead of inline avatar divs
export function Avatar({ email, size = 40, userEmail = null, showUploadOnTap = false }) {
  const { getAvatar, updateAvatar } = useAvatars()
  const [uploading, setUploading] = useState(false)
  const [showSheet, setShowSheet] = useState(false)
  const fileInput = useRef()
  const member = getMember(email)
  const avatarUrl = getAvatar(email)
  const isOwn = userEmail && email?.toLowerCase() === userEmail?.toLowerCase()
  const canUpload = showUploadOnTap && isOwn

  async function handleFile(e) {
    const file = e.target.files[0]
    if (!file) return
    setUploading(true)
    setShowSheet(false)
    await updateAvatar(email, file, uploadToR2)
    setUploading(false)
  }

  function handleTap() {
    if (canUpload) setShowSheet(true)
  }

  return (
    <>
      <div
        onClick={handleTap}
        style={{
          width: size, height: size, borderRadius: '50%',
          background: avatarUrl ? 'transparent' : `linear-gradient(135deg, ${member.color}, ${member.color}cc)`,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          color: 'white', fontWeight: '700', fontSize: Math.round(size * 0.38) + 'px',
          flexShrink: 0, overflow: 'hidden', position: 'relative',
          cursor: canUpload ? 'pointer' : 'default',
          boxShadow: `0 2px 8px ${member.color}44`,
        }}
      >
        {avatarUrl ? (
          <img src={avatarUrl} alt={member.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        ) : uploading ? (
          <span style={{ fontSize: Math.round(size * 0.3) + 'px' }}>⏳</span>
        ) : (
          member.name.charAt(0).toUpperCase()
        )}
        {canUpload && !uploading && (
          <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0)', display: 'flex', alignItems: 'center', justifyContent: 'center' }} />
        )}
      </div>

      {/* Upload bottom sheet */}
      {showSheet && (
        <div
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 2000, display: 'flex', alignItems: 'flex-end' }}
          onClick={() => setShowSheet(false)}
        >
          <div
            style={{ background: 'var(--bg-card)', borderRadius: '20px 20px 0 0', width: '100%', padding: '24px 24px 40px' }}
            onClick={e => e.stopPropagation()}
          >
            <div style={{ width: '36px', height: '4px', background: 'var(--border)', borderRadius: '2px', margin: '0 auto 24px' }} />
            <p style={{ fontSize: '17px', fontWeight: '700', color: 'var(--text-primary)', marginBottom: '20px', textAlign: 'center' }}>Update Profile Photo</p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <button
                onClick={() => { fileInput.current.setAttribute('capture', 'user'); fileInput.current.click() }}
                style={{ width: '100%', padding: '16px', background: '#e94560', color: 'white', border: 'none', borderRadius: '14px', fontSize: '16px', fontWeight: '600', cursor: 'pointer' }}
              >
                📷 Take Photo
              </button>
              <button
                onClick={() => { fileInput.current.removeAttribute('capture'); fileInput.current.click() }}
                style={{ width: '100%', padding: '16px', background: 'var(--bg-tertiary)', color: 'var(--text-primary)', border: 'none', borderRadius: '14px', fontSize: '16px', fontWeight: '600', cursor: 'pointer' }}
              >
                🖼️ Choose from Library
              </button>
              {avatarUrl && (
                <button
                  onClick={async () => {
                    setShowSheet(false)
                    await import('./supabase').then(({ supabase }) =>
                      supabase.from('profiles').upsert([{ email: email.toLowerCase(), avatar_url: null }], { onConflict: 'email' })
                    )
                  }}
                  style={{ width: '100%', padding: '16px', background: 'var(--bg-tertiary)', color: '#ff3b30', border: 'none', borderRadius: '14px', fontSize: '16px', fontWeight: '600', cursor: 'pointer' }}
                >
                  Remove Photo
                </button>
              )}
              <button
                onClick={() => setShowSheet(false)}
                style={{ width: '100%', padding: '16px', background: 'transparent', color: 'var(--text-tertiary)', border: 'none', borderRadius: '14px', fontSize: '16px', cursor: 'pointer' }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <input ref={fileInput} type="file" accept="image/*" style={{ display: 'none' }} onChange={handleFile} />
    </>
  )
}

export { getMember }
export default Avatar
